import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './InviteTalentModal.scss';

import { getUsername, getInviteLink, isBrand, getBrandRegistrationCode, getRegistrationCode } from '../../Helpers/user_helpers';
import { copyToClipboard } from '../../Helpers/helpers';

import Modal from '../General/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';

const InviteTalentModal = props => {
  const { user } = props;
  const signupUrl = getInviteLink(user);
  const registrationCode = isBrand(user) ? getBrandRegistrationCode(user) : getRegistrationCode(user);

  useEffect(() => {
    window.__ADD_EVENT__('General - Invite Talent', { isBrand: isBrand(user), username: getUsername(user) });
  }, []);

  const copyLink = () => copyToClipboard(signupUrl, true);

  return (
    <Modal smallForm visible close={props.closeModal} showClose isNestedModal>
      <div className='invite-talent-modal-outer-container'>
        <div className='invite-talent-modal-inner'>
          <div className='invite-talent-modal-header-container'>
            <div className='invite-talent-modal-header'>Invite Talent</div>
            <div className='invite-talent-modal-subheader'>
              Send this link to your talent to invite them to join ShopMy. This link can be used as many times as you need.
            </div>
          </div>

          {registrationCode?.code ? (
            <>
              <div className='invite-talent-modal-link-header'>Referral Link</div>
              <div className='invite-talent-modal-link-container' onClick={copyLink}>
                <div className='invite-talent-modal-link'>{signupUrl}</div>

                <button className='invite-talent-modal-link-copy' onClick={copyLink}>
                  <FontAwesomeIcon icon={faCopy} />
                </button>
              </div>
              <div className='invite-talent-modal-link-disclaimer'>
                Please do not share this link publicly. Talent using this link will bypass our Waitlist application.
              </div>
            </>
          ) : (
            <div className='invite-talent-modal-subheader' style={{ marginBottom: 20 }}>
              You currently do not have a registration code set up. Please create one in your{' '}
              <Link to='/settings?tab=Tokens' onClick={props.closeModal}>
                Settings
              </Link>{' '}
              to start inviting talent.
            </div>
          )}

          <div className='invite-talent-modal-buttons'>
            <button className='invite-talent-modal-button primary' onClick={props.closeModal}>
              Done
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

InviteTalentModal.propTypes = {
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  // functions go here
})(InviteTalentModal);
